// Define action types
import {RuleType} from '../enums';
import {AutomationChooseOptions, AutomationContextType, AutomationFilter} from './model';
import {priority} from '@priority-software/priority-proto-api/lib';
import {AlertListItem} from './types';
import {TreeNodeProps} from '@priority-software/priority-style-react';

// Define generic action type
type Action<T, P = undefined> = {
    type: T;
    payload?: P;
};

// Define automation action types

export enum ActionTypes {
    UPDATE_LIST_RESPONSE = 'UPDATE_LIST_RESPONSE',
    OPEN_AUTOMATION = 'OPEN_AUTOMATION',
    CLOSE_AUTOMATION = 'CLOSE_AUTOMATION',
    SET_AUTOMATION_TYPE = 'SET_AUTOMATION_TYPE',
    SET_AUTOMATION_CHOOSES = 'SET_AUTOMATION_CHOOSES',
    OPEN_SINGLE_RULE = 'OPEN_SINGLE_RULE',
    CLOSE_SINGLE_RULE = 'CLOSE_SINGLE_RULE',
    SET_AUTOMATION_RULES = 'SET_AUTOMATION_RULES',
    SET_APPLIED_FILTERS = 'SET_APPLIED_FILTERS',
    REMOVE_APPLIED_FILTERS = 'REMOVE_APPLIED_FILTERS',
    SET_ACTIVE_STATE = 'SET_ACTIVE_STATE',
    REMOVE_RULE = 'REMOVE_RULE',
    HANDLE_SEARCH = 'HANDLE_SEARCH',
    SAVE_RULE = 'SAVE_RULE',
    HANDLE_RULE_FILTERS = 'HANDLE_RULE_FILTERS',
    UPDATE_OPEN_RULE = 'UPDATE_RULE',
    SET_SELECTED_RULE_INDEX = 'SET_SELECTED_RULE_INDEX',
    SET_AI_RULE_SUGGESTION = 'SET_AI_RULE_SUGGESTION',
    DISPATCH_STATE = 'DISPATCH_STATE',
    SET_COPYING_STATE = 'SET_COPYING_STATE',
    SET_EMAIL_TEMPLATE_FIELDS = 'SET_EMAIL_TEMPLATE_FIELDS'
}

type UpdateListResponseAction = Action<
    ActionTypes.UPDATE_LIST_RESPONSE,
    {data: priority.netitems.form.IAlert[]}
>;
type OpenAutomationAction = Action<ActionTypes.OPEN_AUTOMATION>;
type CloseAutomationAction = Action<ActionTypes.CLOSE_AUTOMATION>;
type SetAutomationTypeAction = Action<ActionTypes.SET_AUTOMATION_TYPE, {type: RuleType}>;
type SetAutomationChoosesAction = Action<
    ActionTypes.SET_AUTOMATION_CHOOSES,
    {choosesOptions: AutomationChooseOptions}
>;
type OpenSingleRuleAction = Action<
    ActionTypes.OPEN_SINGLE_RULE,
    {ruleNumber?: number; newEditorSupport: boolean, CoverLetters?: priority.netitems.form.IAlertMessage[]}
>;
type CloseSingleRuleAction = Action<ActionTypes.CLOSE_SINGLE_RULE>;
type SetAutomationRulesAction = Action<
    ActionTypes.SET_AUTOMATION_RULES,
    {rules: Array<AlertListItem> | null}
>;
type SetAppliedFiltersAction = Action<ActionTypes.SET_APPLIED_FILTERS, {filter: AutomationFilter}>;
type RemoveAppliedFiltersAction = Action<
    ActionTypes.REMOVE_APPLIED_FILTERS,
    {filterName: string; value: string | number}
>;
type RemoveRuleAction = Action<ActionTypes.REMOVE_RULE, {ruleNumber: number}>;
type SetActiveState = Action<
    ActionTypes.SET_ACTIVE_STATE,
    {ruleNumber: number; isActive: boolean; rules: priority.netitems.form.IAlert[]}
>;
type HandleSearch = Action<ActionTypes.HANDLE_SEARCH, {searchValue: string}>;
type SetSelectedRuleIndexAction = Action<ActionTypes.SET_SELECTED_RULE_INDEX, {index: number}>;
type SaveRule = Action<ActionTypes.SAVE_RULE, {rules: priority.netitems.form.IAlert[]}>;
type HandleRuleFilters = Action<ActionTypes.HANDLE_RULE_FILTERS>;
type UpdateOpenRule = Action<
    ActionTypes.UPDATE_OPEN_RULE,
    {data: Partial<priority.netitems.form.IAlert>}
>;
type SetAIRuleAction = Action<ActionTypes.SET_AI_RULE_SUGGESTION, Partial<AutomationContextType>>;
type DispatchStateAction = Action<ActionTypes.DISPATCH_STATE, Partial<AutomationContextType>>;
type SetCopyingStateAction = Action<ActionTypes.SET_COPYING_STATE, {isCopying: boolean}>;
type SetEmailTemplateFieldsAction = Action<
    ActionTypes.SET_EMAIL_TEMPLATE_FIELDS,
    {emailTemplateFields: TreeNodeProps}
>;

export type AutomationAction =
    | UpdateListResponseAction
    | OpenAutomationAction
    | CloseAutomationAction
    | SetAutomationTypeAction
    | SetAutomationChoosesAction
    | OpenSingleRuleAction
    | CloseSingleRuleAction
    | SetAutomationRulesAction
    | SetAppliedFiltersAction
    | RemoveAppliedFiltersAction
    | RemoveRuleAction
    | SetActiveState
    | HandleSearch
    | SaveRule
    | UpdateOpenRule
    | SetSelectedRuleIndexAction
    | HandleRuleFilters
    | SetAIRuleAction
    | DispatchStateAction
    | SetCopyingStateAction
    | SetEmailTemplateFieldsAction;
